// extracted by mini-css-extract-plugin
export default {"pricesList":"PricesList_pricesList__1F+ix","isDisabledPricesList":"PricesList_isDisabledPricesList__QQYHT"};